/* ============================================================
   Amor – Autoload / Infinite Scroll für Produktlisten (Stand 22.09.2026)
   Lädt auf Kollektions- und Suchergebnisseiten automatisch die
   nächste Seite, sobald der "Mehr laden"-Button in die Nähe des
   sichtbaren Bereichs scrollt – bis zum Ende der Liste.
   Das eigentliche Nachladen macht weiterhin die Theme-Logik
   (assets/collection-load-more.js) – dieses Skript klickt den
   Button nur programmatisch.
   Voraussetzung: Sektionseinstellung "Pagination style" = "Load more".
   Eingebunden in layout/theme.liquid.
   ============================================================ */
(function () {
  'use strict';

  /* Einstellungen */
  var MAX_AUTO_LOADS = 0;          /* 0 = unbegrenzt (echtes Infinite Scroll).
                                      Alternativ z. B. 3 = nach 3 automatischen Nachladungen erscheint der
                                      Button wieder; ein Klick darauf startet weitere 3 Nachladungen. */
  var ROOT_MARGIN = '600px 0px';   /* Vorlauf: nachladen, sobald der Button noch 600px unterhalb des sichtbaren Bereichs ist */

  if (!('IntersectionObserver' in window)) return; /* sehr alte Browser: Button bleibt wie bisher manuell nutzbar */

  var autoLoads = 0;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var btn = entry.target;
      var host = btn.closest('collection-load-more');
      /* Letzte Seite erreicht: das Theme versteckt den Container per Klasse "hidden" */
      if (!host || host.classList.contains('hidden')) { observer.unobserve(btn); return; }
      /* Ladevorgang läuft bereits (das Theme setzt "disabled" während des Fetch) */
      if (btn.hasAttribute('disabled')) return;
      /* Nur relevant, wenn MAX_AUTO_LOADS > 0 gesetzt ist */
      if (MAX_AUTO_LOADS > 0 && autoLoads >= MAX_AUTO_LOADS) { observer.unobserve(btn); return; }
      autoLoads += 1;
      btn.click();
    });
  }, { rootMargin: ROOT_MARGIN });

  /* Alle aktuellen "Mehr laden"-Buttons beobachten. Erneutes observe() liefert sofort den
     aktuellen Sichtbarkeitsstatus – so geht es nach jedem Nachladen automatisch weiter,
     solange der Button noch im Sichtbereich liegt. */
  function arm() {
    var buttons = document.querySelectorAll('collection-load-more .js-btn-load-more');
    Array.prototype.forEach.call(buttons, function (btn) {
      observer.unobserve(btn);
      observer.observe(btn);
    });
  }

  /* Echter Klick des Nutzers (nicht unser programmatischer): Zähler zurücksetzen
     (nur relevant, wenn MAX_AUTO_LOADS > 0) */
  document.addEventListener('click', function (event) {
    if (!event.isTrusted) return;
    var btn = event.target.closest && event.target.closest('collection-load-more .js-btn-load-more');
    if (btn) autoLoads = 0;
  }, true);

  /* Neu scharf schalten, wenn sich das Produktraster ändert:
     nach dem Nachladen, nach Filter-/Sortierwechsel (Theme baut den Container neu auf)
     und im Theme-Editor (shopify:section:load) */
  var mutationObserver = new MutationObserver(function () { arm(); });

  function init() {
    arm();
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', arm);
})();